<template>
  <div
    v-if="loaded"
    class="practice_page"
    @contextmenu="preventNativeLongPress"
    @selectstart="preventNativeLongPress"
  >
    <topController />
    <mainController />
    <editor />
    <layerPanel />
    <noviceGuide />
  </div>
</template>

<script>
import topController from "./components/topController.vue";
import mainController from "./components/mainController.vue";
import editor from "./components/editor.vue";
import layerPanel from "./components/layerPanel.vue";
import noviceGuide from "./components/noviceGuide.vue";
import { login } from "@/plugins/utils.js";
export default {
  components: {
    topController,
    mainController,
    editor,
    layerPanel,
    noviceGuide,
  },
  data() {
    return {
      loaded: false,
    };
  },
  created() {
    login(() => {
      this.loaded = true;
    }, this);
  },
  methods: {
    preventNativeLongPress(event) {
      const target = event.target;
      const editableSelector = "input, textarea, [contenteditable='true']";
      if (target && target.closest && target.closest(editableSelector)) {
        return;
      }
      event.preventDefault();
    },
  },
};
</script>

<style>
.practice_page,
.practice_page * {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.practice_page input,
.practice_page textarea,
.practice_page [contenteditable="true"] {
  -webkit-touch-callout: default;
  -webkit-user-select: text;
  user-select: text;
}

.practice_page img {
  -webkit-user-drag: none;
}
</style>
